import { useMappingQuery } from 'api/MappingsAPI';
import { debounce } from 'lodash';
import { DEBOUNCE_TIMEOUTS_MS } from 'modules/customEvents/constants';
import { GenericDataType } from 'modules/domains';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { ReactNode, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { formatFieldTypeForDisplay } from '../utils';
import { PurchaseMappingsContext } from './PurchaseMappingsContext';

export const PurchaseMappingsContextProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useDispatch();
  const {
    data = [],
    isError: isErrorPurchaseMappings,
    isLoading: isLoadingPurchaseMappings,
    refetch,
  } = useMappingQuery(
    { dataType: GenericDataType.Purchase, fetchLatest: true, filterOutHiddenFields: false },
    {
      onError: (error) => {
        dispatch(
          addNegativeToastWithErrorId(
            'Problem fetching purchase mappings',
            'PurchaseMappingsContextProvider',
            error,
          ),
        );
      },
    },
  );

  const purchaseMappings = useMemo(() => {
    return data.map((mapping) => {
      return {
        ...mapping,
        fieldType: formatFieldTypeForDisplay(mapping.fieldType),
      };
    });
  }, [data, isLoadingPurchaseMappings]);

  const refetchPurchaseMappings = debounce(() => refetch(), DEBOUNCE_TIMEOUTS_MS.refetchMappings);

  const context = {
    isErrorPurchaseMappings,
    isLoadingPurchaseMappings,
    refetchPurchaseMappings,
    purchaseMappings,
  };

  return (
    <PurchaseMappingsContext.Provider value={context}>{children}</PurchaseMappingsContext.Provider>
  );
};
